import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ListItemSecondaryAction, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { REQUIRE_OPTIONS } from './types';
import { useTrialHasStarted } from './useTrialHasStarted';

const QuestionList = ({
  question, index, required, onDelete,
}) => {
  const trialHasStarted = useTrialHasStarted();

  return (
    <>
      <div>
        {`${index + 1}) ${question.question.de || question.question.text}`}
      </div>
      {REQUIRE_OPTIONS.indexOf(question.type) > -1 && (
      <div>
        {`; [${question.options.length}]`}
        <FormattedMessage id="questionlist.options" />
      </div>
      )}
      {
      required && (
        <div style={{ color: 'red' }}>
          &nbsp;
          <FormattedMessage id="questioneditor.required" />
        </div>
      )
    }
      <ListItemSecondaryAction
        onClick={(e) => {
          e.stopPropagation();
          if (trialHasStarted) {
            return;
          }
          onDelete(question.id);
        }}
      >
        <IconButton disabled={trialHasStarted} edge="end" size="large">
          <Delete />
        </IconButton>
      </ListItemSecondaryAction>
    </>
  );
};

export default QuestionList;

QuestionList.propTypes = {
  question: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool,
  ])).isRequired,
  index: PropTypes.number.isRequired,
  required: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};
